<rt-dropdown [width]="DropdownWidth.Small">
  @for (option of options; track trackByLevel($index, option)) {
    <rt-dropdown-item [isSelected]="option.isSelected" (click)="select({ level: option.level })">
      <rt-icon prefix [name]="option.icon"></rt-icon>
      {{ option.label | translate }}</rt-dropdown-item
    >
  }
</rt-dropdown>
